import { InstantTransferSettleDialogDTO } from 'shared/modules/superpay/SuperPayDTO';
import { InstantTransferMultipleSettleDialogContent } from 'shared/modules/superpay/instant-transfer-settle/InstantTransferMultipleSettleDialogContent';
import { InstantTransferSettleDialogContent } from 'shared/modules/superpay/instant-transfer-settle/InstantTransferSettleDialogContent';

interface InstantTransferRestrictedProps {
  onClose: () => void;
  onSuccess: () => void;
  settleInformation: InstantTransferSettleDialogDTO;
}

export function InstantTransferUnlockAccess({
  onClose,
  onSuccess,
  settleInformation,
}: InstantTransferRestrictedProps) {
  const loadCounts = settleInformation?.loads?.length || 0;
  const isMultiple = loadCounts > 1;

  if (isMultiple) {
    return (
      <InstantTransferMultipleSettleDialogContent
        onClose={onClose}
        onSuccess={onSuccess}
        settleInformation={settleInformation}
        title="Unlock Instant Transfer Access"
      />
    );
  }

  return (
    <InstantTransferSettleDialogContent
      onClose={onClose}
      onSuccess={onSuccess}
      settleInformation={settleInformation}
      title="Unlock Instant Transfer Access"
    />
  );
}
